import { Switch, styled } from "@mui/material";
import { Product } from "../util/Utils";

const ThemeSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: Product.ColorCode(),
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: Product.ColorCode(),
  },
}));
export default ThemeSwitch;
